import * as Types from '../../api';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GroupNameQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type GroupNameQuery = { __typename?: 'Query', groups?: { __typename?: 'GroupList', items: Array<{ __typename?: 'Group', name: string } | null> } | null };

export type SavePickupGroupMutationVariables = Types.Exact<{
  id?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  domainId?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  name: Types.Scalars['String']['input'];
}>;


export type SavePickupGroupMutation = { __typename?: 'Mutation', savePickupGroup: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', type: string, context?: string | null, location: Array<string> }> | null } };

export type CreatePickupGroupMutationVariables = Types.Exact<{
  domainId: Types.Scalars['Int']['input'];
  name: Types.Scalars['String']['input'];
  members: Array<Types.Scalars['Int']['input']>;
}>;


export type CreatePickupGroupMutation = { __typename?: 'Mutation', createPickupGroup: { __typename?: 'SaveResult', id?: number | null, errors?: Array<{ __typename?: 'Error', type: string, context?: string | null, location: Array<string> }> | null } };

export type PickupGroupListFragment = { __typename?: 'Group', name: string };

export const PickupGroupListFragmentDoc = gql`
    fragment PickupGroupList on Group {
  name
}
    `;
export const GroupNameDocument = gql`
    query GroupName($id: Int!) {
  groups(id: $id) {
    items {
      name
    }
  }
}
    `;

/**
 * __useGroupNameQuery__
 *
 * To run a query within a React component, call `useGroupNameQuery` and pass it any options that fit your needs.
 * When your component renders, `useGroupNameQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGroupNameQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGroupNameQuery(baseOptions: Apollo.QueryHookOptions<GroupNameQuery, GroupNameQueryVariables> & ({ variables: GroupNameQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GroupNameQuery, GroupNameQueryVariables>(GroupNameDocument, options);
      }
export function useGroupNameLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GroupNameQuery, GroupNameQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GroupNameQuery, GroupNameQueryVariables>(GroupNameDocument, options);
        }
export function useGroupNameSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GroupNameQuery, GroupNameQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GroupNameQuery, GroupNameQueryVariables>(GroupNameDocument, options);
        }
export type GroupNameQueryHookResult = ReturnType<typeof useGroupNameQuery>;
export type GroupNameLazyQueryHookResult = ReturnType<typeof useGroupNameLazyQuery>;
export type GroupNameSuspenseQueryHookResult = ReturnType<typeof useGroupNameSuspenseQuery>;
export type GroupNameQueryResult = Apollo.QueryResult<GroupNameQuery, GroupNameQueryVariables>;
export const SavePickupGroupDocument = gql`
    mutation SavePickupGroup($id: Int, $domainId: Int, $name: String!) {
  savePickupGroup(id: $id, domainId: $domainId, name: $name) {
    id
    errors {
      type
      context
      location
    }
  }
}
    `;
export type SavePickupGroupMutationFn = Apollo.MutationFunction<SavePickupGroupMutation, SavePickupGroupMutationVariables>;

/**
 * __useSavePickupGroupMutation__
 *
 * To run a mutation, you first call `useSavePickupGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSavePickupGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [savePickupGroupMutation, { data, loading, error }] = useSavePickupGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      domainId: // value for 'domainId'
 *      name: // value for 'name'
 *   },
 * });
 */
export function useSavePickupGroupMutation(baseOptions?: Apollo.MutationHookOptions<SavePickupGroupMutation, SavePickupGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SavePickupGroupMutation, SavePickupGroupMutationVariables>(SavePickupGroupDocument, options);
      }
export type SavePickupGroupMutationHookResult = ReturnType<typeof useSavePickupGroupMutation>;
export type SavePickupGroupMutationResult = Apollo.MutationResult<SavePickupGroupMutation>;
export type SavePickupGroupMutationOptions = Apollo.BaseMutationOptions<SavePickupGroupMutation, SavePickupGroupMutationVariables>;
export const CreatePickupGroupDocument = gql`
    mutation CreatePickupGroup($domainId: Int!, $name: String!, $members: [Int!]!) {
  createPickupGroup(domainId: $domainId, name: $name, members: $members) {
    id
    errors {
      type
      context
      location
    }
  }
}
    `;
export type CreatePickupGroupMutationFn = Apollo.MutationFunction<CreatePickupGroupMutation, CreatePickupGroupMutationVariables>;

/**
 * __useCreatePickupGroupMutation__
 *
 * To run a mutation, you first call `useCreatePickupGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreatePickupGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createPickupGroupMutation, { data, loading, error }] = useCreatePickupGroupMutation({
 *   variables: {
 *      domainId: // value for 'domainId'
 *      name: // value for 'name'
 *      members: // value for 'members'
 *   },
 * });
 */
export function useCreatePickupGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreatePickupGroupMutation, CreatePickupGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreatePickupGroupMutation, CreatePickupGroupMutationVariables>(CreatePickupGroupDocument, options);
      }
export type CreatePickupGroupMutationHookResult = ReturnType<typeof useCreatePickupGroupMutation>;
export type CreatePickupGroupMutationResult = Apollo.MutationResult<CreatePickupGroupMutation>;
export type CreatePickupGroupMutationOptions = Apollo.BaseMutationOptions<CreatePickupGroupMutation, CreatePickupGroupMutationVariables>;